// @ts-nocheck
import localModeActionTypes from './localModeActionTypes';
const { SET_IS_RECONNECTING } = localModeActionTypes;
const setIsReconnecting = (isReconnecting) => ({
  type: SET_IS_RECONNECTING,
  isReconnecting,
});

export default setIsReconnecting;
